<article class="lum-page lum-page__card lum-c-channel-details">
  <div
    class="overlay"
    lumAppLoader
    [loading]="(loading$ | async) || false"
    [classes]="'loading'"
  ></div>

  <ng-container *ngIf="currentChannel$ | async as _currentChannel">
    <header class="lum-page-header">
      <h2 class="lum-page-header__heading">
        <a routerLink="/channels/v2/list">Channels</a> /
        {{ _currentChannel.label }}
      </h2>
      <div class="lum-page-header__actions">
        <a
          class="lum-button lum-button--secondary"
          [routerLink]="['/channels/v2', _currentChannel.id, 'edit']"
          >Edit</a
        >
      </div>
    </header>

    <mat-tab-group>
      <ng-container *ngIf="hasPushStocksToOms">
        <mat-tab label="Product Mapping">
          <div class="lum-page-content">
            <ng-container *ngIf="!(loading$ | async)">
              <lum-channel-product-mapping-v2
                [channel]="currentChannel$ | async"
              ></lum-channel-product-mapping-v2>
            </ng-container>
          </div>
        </mat-tab>
      </ng-container>
      <mat-tab label="Details">
        <div class="lum-page-content">
          <h5>Channel Details</h5>
          <div class="row">
            <div class="col-lg-4">
              <div class="form-group">
                <label class="lum-label">Channel Name</label>
                <div class="text-medium">
                  {{ (currentChannel$ | async)?.label }}
                </div>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="form-group">
                <label class="lum-label">Warehouse Group</label>
                <div class="text-medium">
                  {{ (currentChannel$ | async)?.warehouseGroup?.label }}
                </div>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="form-group">
                <label class="lum-label">Tags</label>
                <div>
                  <span
                    *ngFor="
                      let tag of (currentChannel$ | async)?.tags;
                      trackBy: trackById
                    "
                    class="lum-chip lum-chip--small mr-2"
                    >{{ tag?.name }}</span
                  >
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-4">
              <div class="form-group">
                <div class="lum-label">Internal Sales Channel</div>
                <div class="text-medium">
                  <span
                    *ngIf="
                      (currentChannel$ | async)?.isPOSChannel;
                      else notPOSChannel
                    "
                    class="
                      lum-chip lum-chip--small bg-green-400 text-green-800 border-color-green-800
                    "
                  >
                    YES
                  </span>
                  <ng-template #notPOSChannel>
                    <span class="lum-chip lum-chip--small"> NO </span>
                  </ng-template>
                </div>
              </div>
            </div>
            <div class="col-lg-8">
              <div class="form-group">
                <label class="lum-label">Description</label>
                <div class="text-medium">
                  {{ (currentChannel$ | async)?.description }}
                </div>
              </div>
            </div>
          </div>

          <ng-container *ngIf="'red_DV-2964_automated_billing' | featureFlag">
            <hr />
            <h5>Settings</h5>
            <div class="row">
              <div class="col-4">
                <div class="form-group">
                  <div class="lum-label">Create Invoice Automatically</div>
                  <span
                    *ngIf="
                      channelMetafields?.[
                        eChannelMetaKey.CREATE_INVOICE_AUTOMATICALLY_FOR_AN_ORDER
                      ];
                      else autoCreateInvoiceDisabled
                    "
                    class="
                      lum-chip lum-chip--small bg-green-400 text-green-800 border-color-green-800
                    "
                  >
                    ENABLED
                  </span>

                  <ng-template #autoCreateInvoiceDisabled>
                    <span class="lum-chip lum-chip--small"> DISABLED </span>
                  </ng-template>
                </div>
              </div>

              <ng-container
                *ngIf="
                  channelMetafields?.[
                    eChannelMetaKey.CREATE_INVOICE_AUTOMATICALLY_FOR_AN_ORDER
                  ]
                "
              >
                <div class="col-4">
                  <div class="form-group">
                    <div class="lum-label">Invoice Type</div>
                    <div class="text-medium">
                      {{ (currentChannel$ | async)?.invoiceType?.label }}
                    </div>
                  </div>
                </div>
                <div class="col-4">
                  <div class="form-group">
                    <div class="lum-label">Invoice Creation Timing</div>
                    <div class="text-medium">
                      {{
                        channelMetafields?.[
                          eChannelMetaKey.CREATE_INVOICE_CREATION_TIMING
                        ] || 'N/A'
                      }}
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </ng-container>

          <hr />
          <h5>Order Source</h5>
          <div class="row">
            <div class="col-4">
              <div class="form-group">
                <div class="lum-label">Pull Sales Order</div>
                <span
                  *ngIf="
                    (currentChannel$ | async)?.pullOrderIntegrationMapping;
                    else notPullSalesOrder
                  "
                  class="
                    lum-chip lum-chip--small bg-green-400 text-green-800 border-color-green-800
                  "
                >
                  ENABLED
                </span>

                <ng-template #notPullSalesOrder>
                  <span class="lum-chip lum-chip--small"> DISABLED </span>
                </ng-template>
              </div>
            </div>
            <div class="col-4">
              <div class="form-group">
                <div class="lum-label">Pull Orders From</div>
                <div class="text-medium">
                  {{
                    (currentChannel$ | async)?.pullOrderIntegrationMapping
                      ?.appIntegrationAccountName
                  }}
                </div>
              </div>
            </div>
            <div class="col-4">
              <div class="form-group">
                <div class="lum-label">OMS Store</div>
                <div class="text-medium">
                  {{
                    (currentChannel$ | async)?.pullOrderIntegrationMapping
                      ?.storeName
                  }}
                </div>
              </div>
            </div>
          </div>

          <ng-container
            *ngIf="'red_DV-3027_Integration_Field_Mapping' | featureFlag"
          >
            <div class="row">
              <div class="col-md-6">
                <div class="lum-label">Incoming Custom Field Mapping</div>
                <div class="table-responsive">
                  <table class="lum-table lum-table--classic striped border">
                    <thead>
                      <th>Incoming Field</th>
                      <th>LUM Field</th>
                    </thead>
                    <tbody>
                      <tr
                        *ngFor="
                          let field of (currentChannel$ | async)
                            ?.pullOrderIntegrationMapping?.options
                            ?.incomingCustomFieldMapping;
                          trackBy: trackByKey
                        "
                      >
                        <td>{{ field?.incomingField }}</td>
                        <td>{{ field?.lumField }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </ng-container>

          <row *ngIf="(currentChannel$ | async)?.filters?.length">
            <div class="col-lg-12">
              <tr>
                <div class="lum-label">Incoming Order Filters</div>
                <table class="lum-table lum-table--classic striped border">
                  <thead>
                    <tr>
                      <th>Property</th>
                      <th>Operator</th>
                      <th>Value</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      *ngFor="
                        let filter of (currentChannel$ | async)?.filters;
                        trackBy: trackByKey
                      "
                    >
                      <td>{{ filter?.key }}</td>
                      <td>{{ filter?.condition }}</td>
                      <td>{{ filter?.value }}</td>
                    </tr>
                  </tbody>
                </table>
              </tr>
            </div>
          </row>

          <hr />
          <h5>Order Destination</h5>
          <div class="row">
            <div class="col-4">
              <div class="form-group">
                <div class="lum-label">Push Orders to Integration</div>
                <span
                  *ngIf="
                    (currentChannel$ | async)?.pushOrderIntegrationMapping;
                    else notPushSalesOrder
                  "
                  class="
                    lum-chip lum-chip--small bg-green-400 text-green-800 border-color-green-800
                  "
                >
                  ENABLED
                </span>

                <ng-template #notPushSalesOrder>
                  <span class="lum-chip lum-chip--small"> DISABLED </span>
                </ng-template>
              </div>
            </div>
            <div class="col-4">
              <div class="form-group">
                <div class="lum-label">Push Orders To Integration</div>
                <div class="text-medium">
                  {{
                    (currentChannel$ | async)?.pushOrderIntegrationMapping
                      ?.appIntegrationAccountName
                  }}
                </div>
              </div>
            </div>
            <div class="col-4">
              <div class="form-group">
                <div class="lum-label">OMS Store</div>
                <div class="text-medium">
                  {{
                    (currentChannel$ | async)?.pushOrderIntegrationMapping
                      ?.storeName
                  }}
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-4">
              <div class="form-group">
                <div class="lum-label">
                  Automatically Push Posted Order After x Minutes
                </div>
                <div class="text-medium">
                  {{
                    (currentChannel$ | async)?.pushOrderIntegrationMapping?.options
                      ?.autoPushOrderAfterMinutes
                  }}
                </div>
              </div>
            </div>
            <div class="col-4">
              <div class="form-group">
                <div class="lum-label">Default Push Order Shipping Method</div>
                <div class="text-medium">{{ currentShippingMethod?.name }}</div>
              </div>
            </div>

            <div class="col-4">
              <div class="form-group">
                <div class="lum-label">
                  Automatically Push Fulfillment Updates to Order Source
                </div>
                <span
                  *ngIf="
                    pushOrderToOmsOptions?.autoPushFulfillmentUpdatesToOrderSource;
                    else autoPushFulfillmentUpdatesToOrderSourceDisabled
                  "
                  class="
                    lum-chip lum-chip--small bg-green-400 text-green-800 border-color-green-800
                  "
                >
                  ENABLED
                </span>

                <ng-template #autoPushFulfillmentUpdatesToOrderSourceDisabled>
                  <span class="lum-chip lum-chip--small"> DISABLED </span>
                </ng-template>
              </div>
            </div>
          </div>

          <ng-container
            *ngIf="
              'red_DV-3027_Integration_Field_Mapping' | featureFlag;
              else oldPushOrderCustomFieldMapping
            "
          >
            <div class="row">
              <div class="col-md-6">
                <div class="lum-label">Push Order Custom Field Mapping</div>
                <div class="table-responsive">
                  <table class="lum-table lum-table--classic striped border">
                    <thead>
                      <th>LUM Field</th>
                      <th>Push Field</th>
                    </thead>
                    <tbody>
                      <tr
                        *ngFor="
                          let field of (currentChannel$ | async)
                            ?.pushOrderIntegrationMapping?.options
                            ?.pushOrderCustomFieldMapping;
                          trackBy: trackByKey
                        "
                      >
                        <td>{{ field?.lumField }}</td>
                        <td>{{ field?.pushField }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-template #oldPushOrderCustomFieldMapping>
            <row
              *ngIf="
                (currentChannel$ | async)?.pushOrderIntegrationMapping?.options
                  ?.pushCustomFields?.length
              "
            >
              <div class="col-lg-12">
                <div class="lum-label">Push Order Custom Fields</div>
                <table class="lum-table lum-table--classic striped border">
                  <thead>
                    <tr>
                      <th>Custom Field Property</th>
                      <th>Custom Field Value</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      *ngFor="
                        let customField of (currentChannel$ | async)
                          ?.pushOrderIntegrationMapping?.options?.pushCustomFields;
                        trackBy: trackByKey
                      "
                    >
                      <td>{{ customField?.key }}</td>
                      <td>{{ customField?.value }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </row>
          </ng-template>

          <hr />
          <h5>Push Inventory Stocks And Unit Cost</h5>
          <div class="row">
            <div class="col-4">
              <div class="form-group">
                <div class="lum-label">Push Stock to Integration</div>
                <span
                  *ngIf="hasPushStocksToOms; else notPushStocks"
                  class="
                    lum-chip lum-chip--small bg-green-400 text-green-800 border-color-green-800
                  "
                >
                  ENABLED
                </span>

                <ng-template #notPushStocks>
                  <span class="lum-chip lum-chip--small"> DISABLED </span>
                </ng-template>
              </div>
            </div>
            <div class="col-4">
              <div class="form-group">
                <div class="lum-label">Push Stock To Integration</div>
                <div class="text-medium">
                  {{
                    (currentChannel$ | async)?.pushStockAppIntegrationAccountName
                  }}
                </div>
              </div>
            </div>
            <div class="col-4">
              <div class="form-group">
                <div class="lum-label">Push Unit Cost</div>
                <span
                  *ngIf="pushStocksToOmsOptions?.pushUnitCost; else notPushUnitCost"
                  class="
                    lum-chip lum-chip--small bg-green-400 text-green-800 border-color-green-800
                  "
                >
                  ENABLED
                </span>

                <ng-template #notPushUnitCost>
                  <span class="lum-chip lum-chip--small"> DISABLED </span>
                </ng-template>
              </div>
            </div>
            <div class="col-4">
              <div class="form-group">
                <div class="lum-label">Include Incoming Stocks as Sellable</div>
                <span
                  *ngIf="
                    pushStocksToOmsOptions?.includeIncomingStocksAsSellable;
                    else notPushStocks
                  "
                  class="
                    lum-chip lum-chip--small bg-green-400 text-green-800 border-color-green-800
                  "
                >
                  ENABLED
                </span>

                <ng-template #notPushStocks>
                  <span class="lum-chip lum-chip--small"> DISABLED </span>
                </ng-template>
              </div>
            </div>
            <div class="col-4">
              <div class="form-group">
                <div class="lum-label">
                  Push Incoming Stocks from Supplier Purchase Orders
                </div>
                <span
                  *ngIf="
                    pushStocksToOmsOptions?.pushIncomingStocksFromSupplierPurchaseOrderEnabled;
                    else pushIncomingStocksFromSupplierPurchaseOrderDisabled
                  "
                  class="
                    lum-chip lum-chip--small bg-green-400 text-green-800 border-color-green-800
                  "
                >
                  ENABLED
                </span>

                <ng-template #pushIncomingStocksFromSupplierPurchaseOrderDisabled>
                  <span class="lum-chip lum-chip--small"> DISABLED </span>
                </ng-template>
              </div>
            </div>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </ng-container>
</article>
